export default "__VITE_ASSET__BVHbghFL__"